import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=198b26fd&lang=pug"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports